import { Action } from '@ngrx/store';
import { BootstrapData, HttpError } from '@rd/types';

export enum TenantActionTypes {
  LOAD_BOOTSTRAP = '[Tenant] Load Bootstrap',
  LOAD_BOOTSTRAP_SUCCESS = '[Tenant] Load Bootstrap Success',
  LOAD_BOOTSTRAP_FAIL = '[Tenant] Load Bootstrap Fail',
  SET_PAGE_LOADING_STATE = '[Tenant] Set Page Loading State',
}

export class LoadBootstrap implements Action {
  readonly type = TenantActionTypes.LOAD_BOOTSTRAP;
}

export class LoadBootstrapSuccess implements Action {
  readonly type = TenantActionTypes.LOAD_BOOTSTRAP_SUCCESS;

  constructor(public payload: BootstrapData) {}
}

export class LoadBootstrapFail implements Action {
  readonly type = TenantActionTypes.LOAD_BOOTSTRAP_FAIL;

  constructor(public payload: HttpError) {}
}

export class SetPageLoadingState implements Action {
  readonly type = TenantActionTypes.SET_PAGE_LOADING_STATE;

  constructor(public payload: { isLoading: boolean }) {}
}

export type TenantActions =
  | LoadBootstrap
  | LoadBootstrapSuccess
  | LoadBootstrapFail
  | SetPageLoadingState;
